import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFire, faUsers, faRobot, faArrowRight, faCheck, faSpinner, faHourglassHalf,
  faMobileScreen, faShieldHalved,
} from '@fortawesome/free-solid-svg-icons';
import './acts.css';
import './Act5_Roadmap.css';

const HIGHLIGHTS = [
  {
    phase: 'Landing next',
    phaseColor: '#0c437c',
    phaseIcon: faSpinner,
    icon: faFire,
    title: 'Fire Safety Module',
    body: 'Extinguishers, alarms, sprinklers, emergency lights, doors, detectors — same depth as Roof, full BS 5839 cycles.',
  },
  {
    phase: 'Landing next',
    phaseColor: '#0c437c',
    phaseIcon: faSpinner,
    icon: faShieldHalved,
    title: 'Audit-ready PDF reports',
    body: 'Branded, signed, and logged. Hand one document to any insurer, board, or regulator.',
  },
  {
    phase: 'On the roadmap',
    phaseColor: '#7c5cff',
    phaseIcon: faHourglassHalf,
    icon: faUsers,
    title: 'Staff Safety Module',
    body: 'PPE registers, training matrices, working-at-height authorisations. Close the loop around your people.',
  },
  {
    phase: 'On the roadmap',
    phaseColor: '#7c5cff',
    phaseIcon: faHourglassHalf,
    icon: faMobileScreen,
    title: 'Native mobile app',
    body: 'Offline-first inspections for iOS and Android. Tap a pin, log a test, it syncs when you’re back on signal.',
  },
  {
    phase: 'Exploring',
    phaseColor: '#b45309',
    phaseIcon: faRobot,
    icon: faRobot,
    title: 'AI Compliance Copilot',
    body: 'Ask in plain English: "Which ladders at UCL are overdue in the next 60 days?" and get the answer.',
  },
];

export default function Act5Roadmap() {
  return (
    <div className="act act-5">
      {/* ── Narrative ── */}
      <div className="act-copy">
        <span className="act-eyebrow">
          <span className="act-eyebrow-dot" /> Act 5 · What&rsquo;s next
        </span>
        <h1 className="act-title">
          We ship <span className="act-title-accent">every month.</span>
          <br />
          Here&rsquo;s what&rsquo;s landing.
        </h1>
        <p className="act-lede">
          CloudSafe is already the deepest roof-safety tool on the market. Fire, Staff,
          Equipment and Electrical modules follow the same blueprint. Our public roadmap
          stays honest — no vaporware, no theatre.
        </p>
        <ul className="act-proofs">
          <li className="act-proof">
            <span className="act-proof-check"><FontAwesomeIcon icon={faCheck} /></span>
            <span><strong>Public roadmap</strong>, updated monthly. Your team can follow along.</span>
          </li>
          <li className="act-proof">
            <span className="act-proof-check"><FontAwesomeIcon icon={faCheck} /></span>
            <span><strong>Same blueprint, module by module.</strong> Predictable rollout, no surprises.</span>
          </li>
          <li className="act-proof">
            <span className="act-proof-check"><FontAwesomeIcon icon={faCheck} /></span>
            <span><strong>Customer-prioritised.</strong> We build what our partners actually push for.</span>
          </li>
        </ul>
        <Link to="/roadmap" className="act-cta">
          <span>See the full roadmap</span>
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>

      {/* ── Stage ── */}
      <div className="act-stage">
        <div className="a5-cards">
          {HIGHLIGHTS.map((h, i) => (
            <article
              key={i}
              className="a5-card"
              style={{ '--phase-color': h.phaseColor, animationDelay: `${i * 90}ms` }}
            >
              <div className="a5-card-phase">
                <FontAwesomeIcon icon={h.phaseIcon} className="a5-card-phase-ico" />
                <span>{h.phase}</span>
              </div>
              <div className="a5-card-ico">
                <FontAwesomeIcon icon={h.icon} />
              </div>
              <h3 className="a5-card-title">{h.title}</h3>
              <p className="a5-card-body">{h.body}</p>
            </article>
          ))}
        </div>

        <div className="a5-thanks">
          <div className="a5-thanks-dot" />
          <span>Thanks for walking through with us.</span>
          <Link to="/roadmap" className="a5-thanks-link">Open full roadmap →</Link>
        </div>
      </div>
    </div>
  );
}
